<template>
  <Html lang="ru">
    <Body class="body">
      <CommonBackground />
      <NuxtLoadingIndicator />
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
    </Body>
    <PopupManager />
    <DeviceRotateOverlay />
  </Html>
</template>

<script setup lang="ts">
import { swipeBehavior } from '@tma.js/sdk';
import useBaseStore from '@base/store/baseStore';
import type { LinksType } from '@base/types/links';

const { setLinksData } = useBaseStore();

useEditor((editorData) => {
  setLinksData(editorData['Ссылки'] as LinksType);
});

onMounted(() => {
  if (!swipeBehavior.isSupported()) {
    return;
  }

  swipeBehavior.mount();
  swipeBehavior.disableVertical();
});
</script>

<style lang="scss" scoped></style>
